import {
  CAPTIONS_HIGH_QUALITY_STYLE,
  TRANSCRIPTION_TYPE_CAPTIONS,
  TRANSCRIPTION_TYPE_TRANSLATED_SUBTITLES
} from "../sagas/constants";

export const TRANSCRIPTION = 'transcription';
export const SYNTAX = 'syntax';
export const GRAMMAR = 'grammar';
export const PUNCTUATION = 'punctuation';

export const TRANSCRIPTION_HQ = 'transcriptionHQ';
export const RESEARCH = 'research';
export const DIFFICULTY = 'difficulty';
export const TIMING = 'timing';
export const CAPTIONS_FORMATTING = 'captionsFormatting';
export const TRANSLATED_SUBTITLES_FORMATTING = 'translatedSubtitlesFormatting';
export const MEANING = 'transferOfMeaning';
export const TERMINOLOGY = 'terminology';
export const COMPLETENESS = 'completeness';
export const ACCURACY = 'grammarAndSpelling';

/**
 * Renamed topics
 * content -> transcription
 * guidelines - > syntax
 * spellingTyposGrammar -> grammar
 * punctuationSyntax - > punctuation
 * namesAndJargon -> research
 */

const getDifficulty = (t) => ({
  [DIFFICULTY]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${DIFFICULTY}`) : null,
    min: 1,
    max: 5,
  },
});

const getStandardReviewForm = (t) => ({
  [TRANSCRIPTION]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${TRANSCRIPTION}`) : null,
    tooltip: t ? t(`EDITOR.dialogJobFeedback.tooltip.${TRANSCRIPTION}`) : null,
    weight: 0.3,
    min: 1,
    max: 5,
  },
  [SYNTAX]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${SYNTAX}`) : null,
    tooltip: t ? t(`EDITOR.dialogJobFeedback.tooltip.${SYNTAX}`) : null,
    weight: 0.25,
    min: 1,
    max: 5,
  },
  [GRAMMAR]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${GRAMMAR}`) : null,
    tooltip: t ? t(`EDITOR.dialogJobFeedback.tooltip.${GRAMMAR}`) : null,
    weight: 0.25,
    min: 1,
    max: 5,
  },
  [PUNCTUATION]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${PUNCTUATION}`) : null,
    tooltip: t ? t(`EDITOR.dialogJobFeedback.tooltip.${PUNCTUATION}`) : null,
    weight: 0.15,
    min: 1,
    max: 5,
  },
  [RESEARCH]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${RESEARCH}`) : null,
    tooltip: t ? t(`EDITOR.dialogJobFeedback.tooltip.${RESEARCH}`) : null,
    weight: 0.05,
    min: 1,
    max: 5,
  },
  ...getDifficulty(t),
});

const getCaptionsHQReviewForm = (t) => ({
  [TRANSCRIPTION_HQ]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${TRANSCRIPTION_HQ}`) : null,
    min: 1,
    max: 5,
  },
  [CAPTIONS_FORMATTING]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${CAPTIONS_FORMATTING}`) : null,
    min: 1,
    max: 5,
  },
  [TIMING]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${TIMING}`) : null,
    min: 1,
    max: 5,
  },
  [RESEARCH]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${RESEARCH}`) : null,
    min: 1,
    max: 5,
  },
  ...getDifficulty(t),
});

const getCaptionsRatingForm = (t, workflowStyle) => {
  switch (workflowStyle) {
    case CAPTIONS_HIGH_QUALITY_STYLE:
      return getCaptionsHQReviewForm(t);
    default:
      return getStandardReviewForm(t);
  }
};

const getTranslatedSubsRatingForm = (t) => ({
  [COMPLETENESS]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${COMPLETENESS}`) : null,
    min: 1,
    max: 5,
  },
  [MEANING]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${MEANING}`) : null,
    min: 1,
    max: 5,
  },
  [ACCURACY]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${ACCURACY}`) : null,
    min: 1,
    max: 5,
  },
  [TERMINOLOGY]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${TERMINOLOGY}`) : null,
    min: 1,
    max: 5,
  },
  [TRANSLATED_SUBTITLES_FORMATTING]: {
    label: t ? t(`EDITOR.dialogJobFeedback.${TRANSLATED_SUBTITLES_FORMATTING}`) : null,
    min: 1,
    max: 5,
  },
  ...getDifficulty(t),
});

export const getRatingDefaults = (t, workflowStyle, transcriptionType) => {
  switch (transcriptionType) {
    case TRANSCRIPTION_TYPE_CAPTIONS:
      return getCaptionsRatingForm(t, workflowStyle);
    case TRANSCRIPTION_TYPE_TRANSLATED_SUBTITLES:
      return getTranslatedSubsRatingForm(t);
    default:
      return getStandardReviewForm(t);
  }
};
